import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import { Credit as CreditType } from '@utils/cook/types'
import translate from '@i18n'
import Blink from '@components/Blink'

const Wrapper = styled.div<{ isFullScreen?: boolean }>`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodycopyCSS },
        },
      },
      colors: { textWeak, staticWhite },
      utils: { ellipsis },
    },
    isFullScreen,
  }) => css`
    ${xxsmallBodycopyCSS};
    color: ${isFullScreen ? staticWhite : textWeak};

    ${ellipsis('100%', 1)}

    ${desktopCSS(css`
      ${isFullScreen &&
      css`
        color: ${textWeak};
      `}
    `)}
  `}
`

const StyledBlink = styled(Blink)<{ isFullScreen?: boolean }>`
  ${({
    theme: {
      colors: { textWeak, staticWhite, staticNeutral400 },
    },
    isFullScreen,
  }) => css`
    color: ${isFullScreen ? staticWhite : textWeak};

    ${desktopCSS(css`
      ${isFullScreen &&
      css`
        color: ${staticNeutral400};
      `}
    `)}
  `}
`

const Credit: FunctionComponent<CreditType & { isFullScreen?: boolean }> = ({
  isFullScreen,
  text,
  link,
}) => {
  if (!text) return null

  return (
    <Wrapper isFullScreen={isFullScreen}>
      {`${translate('gallery.photo')}: `}
      {link?.href ? (
        <StyledBlink {...link} isFullScreen={isFullScreen}>
          {text}
        </StyledBlink>
      ) : (
        text
      )}
    </Wrapper>
  )
}

export default Credit
